import * as _ from 'lodash-es';
import { User } from '../model/user';
import { UsersList } from '../model/users-list';
import { ProfileBuilder } from './profile-builder';
import { VehicleBuilder } from './vehicle-builder';
import { PaymentMethodBuilder } from './payment-method-builder';
export class UserBuilder {
    static buildUser(data) {
        let user = new User();
        user.id = data.user_id;
        user.email = data.email;
        user.name = data.name;
        user.lastName = data.lastname;
        user.phone = data.phone;
        user.zipCode = data.zip;
        user.language = data.lang;
        user.forced_lang = data.forced_lang;
        user.accept_promos = data.accept_promos;
        user.accept_newsletter = data.accept_newsletter;
        user.accept_terms_timestamp = data.accept_terms_timestamp;
        user.defaultInvoiceProfileId = data.default_invoice_profile;
        user.dtoLot = data.dto_lot;
        user.aena = data.aena;
        user.dateLastLogin = data.date_last_login;
        user.dateRegister = data.date_register;
        user.dateUpdate = data.date_modified;
        user.emailConfirmed = data.email_confirmed;
        user.phoneConfirmed = data.phone_confirmed;
        user.points = data.points;
        user.active = data.active;
        user.app_platform = data.app_platform;
        user.app_version = data.app_version;
        user.appRated = data.appRated;
        user.pushPlatform = data.push_platform;
        user.pushToken = data.push_token;
        user.profiles = _.map(data.profiles, data => ProfileBuilder.buildProfile(data));
        user.vehicles = _.map(data.vehicles, data => VehicleBuilder.buildVehicle(data));
        user.paymentMethods = _.map(data.paymethods, data => PaymentMethodBuilder.buildPaymentMethod(data));
        user.auth_id_apple = data.auth_id_apple;
        user.auth_id_facebook = data.auth_id_facebook;
        user.auth_id_google = data.auth_id_google;
        user.config = data.config;
        user.job_profile = data.job_profile;
        return user;
    }
    static buildUsersList(data) {
        const usersList = new UsersList();
        usersList.page = data.page;
        usersList.totalCount = data.total;
        usersList.totalPages = data.totalPages;
        usersList.pagination = data.pagination;
        usersList.users = _.map(data.clients, (user) => {
            return UserBuilder.buildUser(user);
        });
        return usersList;
    }
}
//# sourceMappingURL=user-builder.js.map